<template>
  <div class="rounded-md relative">
    <textarea class="hidden" />
    <VideoDialog v-if="videoSwitch" @closeVideo="closeVideo" @getLink="getLink" />
  </div>
</template>

<script>
/**
 * first add link and script to nuxt.config.js
 *
 * //cdn.jsdelivr.net/simplemde/latest/simplemde.min.css
 * //cdn.jsdelivr.net/simplemde/latest/simplemde.min.js
 *
//  * https://github.com/sparksuite/simplemde-markdown-editor#toolbar-ico, 'unordered-list', 'ordered-list', ns
 * https://github.com/sparksuite/simplemde-markdown-editor#toolbar-icns
 *
 * **/
import VideoDialog from "./VideoDialog.vue";
export default {
  props: {
    placeholder: String,
    value: String,
    disabled: Boolean,
    gallery: String,
  },
  components: { VideoDialog },
  data() {
    return {
      mde: null,
      imageUrlList: "",
      focusClass: ["ring-2", "ring-blue-600", "outline-2", "outline-transparent"],
      videoSwitch: false,
    };
  },
  methods: {
    init() {
      this.mde = new SimpleMDE({
        element: this.$el.querySelector("textarea"),
        lineWrapping: true,
        parsingConfig: {
          allowAtxHeaderWithoutSpace: true,
          strikethrough: false,
          underscoresBreakWords: true,
        },
        placeholder: this.placeholder,
        initialValue: this.value,
        insertTexts: {
          horizontalRule: ["", "\n\n-----\n\n"],
          image: "",
          link: ["[", "](http://)"],
          table: [
            "",
            "\n\n| Column 1 | Column 2 | Column 3 |\n| -------- | -------- | -------- |\n| Text     | Text      | Text     |\n\n",
          ],
        },
        showIcons: ["table"],
        hideIcons: ["side-by-side", "fullscreen"],
        // toolbar: ['bold', 'italic', 'heading', '|', 'quote', 'unordered-list', 'ordered-list', '|', 'link', 'image', 'table', '|', 'preview', 'guide'],
        toolbar: [
          "bold",
          "italic",
          "heading",
          "|",
          "quote",
          "unordered-list",
          "ordered-list",
          "|",
          "link",
          {
            name: "gallery",
            action: async () => {
              const data = await this.$gallery.open(this.gallery);
              if (!data || !data.length) return;

              const imageList = data.map((item) => {
                return `![${item.file_name}](${item.url})`;
              });

              this.mde.codemirror.replaceSelection(imageList.join("\n") + "\n");
            },
            className: "fa fa-picture-o",
            title: "Insert Image",
          },
          "table",
          {
            name: "video",
            action: async () => {
              this.videoSwitch = true;
            },
            className: "fa fa-code",
            title: "Insert Video",
          },
          "|",
          "preview",
          "guide",
        ],
        status: false,
        tabSize: 4,
      });

      if (this.disabled) {
        this.mde.codemirror.options.readOnly = true;
        // disabled toolpanel
      }

      this.mde.codemirror.on("change", () => {
        // save value and html
        const value = this.mde.value();
        this.$emit("input", value);
        this.$emit("change", value);
        // value to markdown
        this.$emit("html", this.mde.markdown(value));
      });
      this.mde.codemirror.on("focus", () => {
        this.$emit("focus");

        // add focus class
        this.$el.querySelector(".CodeMirror").classList.add(...this.focusClass);
      });
      this.mde.codemirror.on("blur", () => {
        this.$emit("blur");
        // remove focus class
        this.$el.querySelector(".CodeMirror").classList.remove(...this.focusClass);
      });
    },
    getLink(value) {
      try {
        let params = this.getUrlParams(value);
        if (value === "" || !params.hasOwnProperty("v")) return;
        let template = `<iframe  src="https://www.youtube.com/embed/${params.v}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen class="w-full h-auto mb-4 min-h-[480px]"></iframe>`;
        this.mde.codemirror.replaceSelection(template + "\n");
      } catch (error) {
        console.log("鏈接視頻失敗：" + error);
      } finally {
        this.videoSwitch = false;
      }
    },
    closeVideo() {
      this.videoSwitch = false;
    },
    getUrlParams(url) {
      let params = {};
      if (url.indexOf("?") != -1) {
        let urlStr = url.split("?")[1];
        let paramsArr = urlStr.split("&");
        for (let i = 0, len = paramsArr.length; i < len; i++) {
          let arr = paramsArr[i].split("=");
          params[arr[0]] = arr[1];
        }
      }
      return params;
    },
  },
  watch: {
    disabled(disable) {
      this.mde.codemirror.options.readOnly = disable;
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    // this.mde.toTextArea();
    // this.mde = null;
  },
};
</script>

<style lang="css">
/* .CodeMirror-wrap {
  @apply rounded-md;
} */
/* 
.CodeMirror-focused {
  @apply ring-2 ring-blue-600 outline-2 outline-transparent;
} */
</style>
